import prism from "prismjs";
window.Prism = window.Prism || {};
window.Prism.manual = true;
import "prismjs/components/prism-jsx";
import "prismjs/components/prism-tsx";
export { prism };